module.exports = __webpack_public_path__ + "img/sdk.db478d38.png";